import type { QuestionBankItem, QuestionBankPatch } from './types';

// How the in-memory list moves once the server has answered. Pure on purpose: the store keeps
// only the request handling, and these are what the tests pin.

/** Newest first - the questions just imported are the ones the teacher came to see. */
export function prependItems(items: QuestionBankItem[], created: QuestionBankItem[]): QuestionBankItem[] {
  return created.concat(items);
}

export function findItem(items: QuestionBankItem[], id: string): QuestionBankItem | null {
  return items.filter((item) => item.id === id)[0] || null;
}

/** Swap in the saved copies in place, so the list order the teacher is looking at does not jump. */
export function replaceItems(items: QuestionBankItem[], updated: QuestionBankItem[]): QuestionBankItem[] {
  if (updated.length === 0) return items;
  const byId = new Map<string, QuestionBankItem>();
  updated.forEach((item) => byId.set(item.id, item));
  return items.map((item) => byId.get(item.id) || item);
}

export function removeIds(items: QuestionBankItem[], ids: string[]): QuestionBankItem[] {
  const dropped = new Set(ids);
  return items.filter((item) => !dropped.has(item.id));
}

/**
 * The PUT body is rebuilt from the whole question (izteach.ts toIzQuestion), so a patch is merged
 * onto the current one before it is sent. A patch carrying `lessonRef: undefined` is how a detach is spelled.
 */
export function mergePatch(item: QuestionBankItem, patch: QuestionBankPatch): QuestionBankItem {
  return { ...item, ...patch };
}
